import * as React from 'react'
import MUITable from '@mui/material/Table'

const Table = (props) => <MUITable {...props} />

export default Table
